import {finishes, sizes, borders, flags, plateSets, defaults, currency, recogniseRegistration, sanitiseState, registrationDisplay, validate, specification} from './builder-model.js';
import {configuredProduct, orderProperties} from './builder-commerce.js';

const $ = selector => document.querySelector(selector);
const storageKey = 'tpd-physical-build-v1';
const form = $('#builderForm');
const dialog = $('#reviewDialog');
const catalogue = JSON.parse($('#physicalProducts')?.textContent || '{}');
const purchaseForm = $('#physicalPurchase');
let attempted = false;
let reviewedState = null;
let toastTimer;
let saved;
try { saved = JSON.parse(localStorage.getItem(storageKey) || 'null'); } catch { saved = null; }
let state = sanitiseState(saved);
const incoming = new URLSearchParams(location.search).get('registration');
if (incoming) state.registration = incoming.slice(0, 10).toUpperCase();

for (const [value, finish] of Object.entries(finishes)) {
  const label = document.createElement('label');
  label.className = 'finish-option';
  const amount = catalogue[value]?.price;
  label.innerHTML = `<input type="radio" name="finish" value="${value}"><span class="finish-content"><span class="finish-sample sample-${value}" aria-hidden="true">AB12</span><span class="finish-title"><strong>${finish.label}</strong><em>${Number.isFinite(amount) ? currency(amount) : 'Quote'}</em></span><span class="finish-desc">${finish.description}</span></span>`;
  $('#finishOptions').append(label);
}

function notify(message) {
  $('#toast').textContent = message;
  $('#toast').classList.add('visible');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => $('#toast').classList.remove('visible'), 3500);
}

function syncControls() {
  $('#registration').value = state.registration;
  $('#plateSize').value = state.size;
  for (const name of ['use', 'finish', 'plates', 'border', 'flag']) {
    for (const radio of form.querySelectorAll(`input[name="${name}"]`)) radio.checked = radio.value === state[name];
  }
}

function details() {
  return [
    ['Registration', registrationDisplay(state) || 'Not entered'],
    ['Intended use', state.use === 'road' ? 'Road use · verification required' : 'Show plate · not for road use'],
    ['Finish', finishes[state.finish].label],
    ['Size', `${sizes[state.size].label} · ${sizes[state.size].dimensions}`],
    ['Plates', plateSets[state.plates]], ['Border', borders[state.border]], ['Flag', flags[state.flag].label]
  ];
}

function renderDetails(target, entries) {
  target.replaceChildren();
  for (const [label, value] of entries) {
    const row = document.createElement('div');
    row.className = 'summary-entry';
    const dt = document.createElement('dt'); dt.textContent = label;
    const dd = document.createElement('dd'); dd.textContent = value;
    row.append(dt, dd); target.append(row);
  }
}

function showErrors(force = false) {
  const errors = validate(state, $('#entitlement').checked);
  for (const name of ['registration', 'size', 'entitlement']) {
    const element = $(`#${name}Error`);
    const visible = Boolean(errors[name]) && (force || attempted || (name !== 'entitlement' && state.registration.trim() !== ''));
    element.hidden = !visible;
    element.textContent = visible ? errors[name] : '';
    const control = name === 'registration' ? $('#registration') : name === 'size' ? $('#plateSize') : $('#entitlement');
    control.setAttribute('aria-invalid', String(visible));
    if (name !== 'registration') control.setAttribute('aria-describedby', `${name}Error`);
  }
  return errors;
}

function render() {
  const isBike = state.size === 'motorcycle';
  for (const radio of form.querySelectorAll('[name="plates"]')) radio.disabled = isBike && radio.value !== 'rear';
  $('#plateStack').className = `plate-stack size-${state.size} border-${state.border} finish-${state.finish}`;
  $('#frontFigure').hidden = state.plates === 'rear';
  $('#rearFigure').hidden = state.plates === 'front';
  const example = !state.registration.trim();
  const formatted = registrationDisplay(state) || 'AB12 CDE';
  const match = recogniseRegistration(formatted);
  let display = formatted;
  if (isBike) {
    const groups = state.use === 'road' && match ? match.groups : formatted.split(/ +/);
    display = groups.length > 1 ? `${groups[0]}\n${groups.slice(1).join(' ')}` : `${formatted.slice(0, Math.ceil(formatted.length / 2))}\n${formatted.slice(Math.ceil(formatted.length / 2))}`;
  }
  for (const plate of document.querySelectorAll('.plate-render')) {
    plate.querySelector('.registration-text').textContent = display;
    const count = Math.max(...display.split('\n').map(line => line.length));
    const base = isBike ? 27 : state.size === 'short' ? 19.3 : 14.8;
    plate.querySelector('.registration-text').style.fontSize = `${Math.min(base, (state.flag === 'none' ? 114 : 99) / Math.max(count, 1))}cqw`;
    plate.setAttribute('aria-label', `${plate.classList.contains('front') ? 'Front' : 'Rear'} plate ${example ? 'example ' : ''}${formatted}, ${finishes[state.finish].label}, ${state.use === 'show' ? 'show use only' : 'unverified specification'}`);
    const identifier = plate.querySelector('.plate-identifier');
    identifier.hidden = state.flag === 'none';
    identifier.replaceChildren();
    if (state.flag !== 'none') {
      const flag = flags[state.flag];
      const img = document.createElement('img'); img.src = new URL(flag.image, import.meta.url).href; img.alt = '';
      const text = document.createElement('span'); text.textContent = flag.identifier;
      identifier.append(img, text);
    }
  }
  $('#stageFinish').textContent = finishes[state.finish].label;
  $('#stageSize').textContent = sizes[state.size].dimensions;
  $('#stageMode').textContent = state.use === 'show' ? 'Show plate · not for road use' : 'Road-use configuration';
  $('#previewCaption').textContent = `${example ? 'Example registration shown. ' : ''}Finish and proportions are illustrative, not a manufacturing proof.`;
  $('#showWarning').hidden = state.use !== 'show';
  $('#registrationHint').textContent = state.use === 'show' ? 'Up to 8 letters or numbers. Your spacing is kept for display use.' : 'Enter the registration exactly as it appears on your document.';
  $('#sizeHint').textContent = isBike ? 'Rear plate only, with a two-line layout.' : state.size === 'short' ? 'Short plates need a character-by-character fit check before manufacture.' : state.size === 'hex' ? 'Hex finish selected with the matching angular profile.' : "Check your vehicle's mounting area before ordering.";
  $('#entitlementText').textContent = state.use === 'road' ? 'I am entitled to use this registration and can provide the required documents.' : 'I understand this is a show plate and must not be used on public roads.';
  const product = configuredProduct(state, catalogue);
  const priceText = product ? currency(product.price) : 'Quote required';
  const labelText = product ? 'Pair price' : 'Custom specification';
  $('#summaryPrice').textContent = priceText;
  $('#mobilePrice').textContent = priceText;
  $('#priceLabel').textContent = labelText;
  $('#mobilePriceLabel').textContent = labelText;
  $('#priceNote').textContent = product ? 'Final pair price. Free UK Next Day Recorded delivery after dispatch. Documents must be checked before manufacture.' : 'Single plates and custom sizes require a quote. UK Next Day Recorded delivery is free after dispatch.';
  $('#carLink').href = `/?registration=${encodeURIComponent(formatted)}#viewer`;
  $('#miniDescription').textContent = plateSets[state.plates];
  const mini = $('#miniPlate');
  mini.className = `size-${state.size} border-${state.border} finish-${state.finish}`;
  mini.replaceChildren($(state.plates === 'front' ? '#frontFigure .plate-shell' : '#rearFigure .plate-shell').cloneNode(true));
  renderDetails($('#summaryList'), details());
  showErrors();
}

form.addEventListener('input', event => {
  if (event.target.id !== 'registration') return;
  state.registration = event.target.value.toUpperCase();
  $('#entitlement').checked = false;
  render();
});
$('#registration').addEventListener('blur', () => {
  state.registration = registrationDisplay(state);
  $('#registration').value = state.registration;
  render();
});
form.addEventListener('change', event => {
  const target = event.target;
  if (target.name === 'registration' || !target.name) { showErrors(); return; }
  state[target.name] = target.value;
  if (target.name === 'use') $('#entitlement').checked = false;
  if (target.name === 'finish') {
    if (state.finish === 'hex') state.size = 'hex';
    else if (state.size === 'hex') state.size = 'standard';
  }
  if (target.name === 'size') {
    if (state.size === 'hex') state.finish = 'hex';
    else if (state.finish === 'hex') state.finish = 'standard';
  }
  if (state.size === 'motorcycle') state.plates = 'rear';
  syncControls(); render();
});

form.addEventListener('submit', event => {
  event.preventDefault();
  attempted = true;
  const errors = showErrors(true);
  if (Object.keys(errors).length) {
    const control = errors.registration ? $('#registration') : errors.size ? $('#plateSize') : $('#entitlement');
    control.focus(); control.scrollIntoView({block: 'center', behavior: 'instant'});
    notify('Check the highlighted details.');
    return;
  }
  reviewedState = {...state};
  $('#reviewRegistration').textContent = registrationDisplay(state);
  renderDetails($('#reviewDetails'), details());
  const product = configuredProduct(reviewedState, catalogue);
  $('#reviewPriceNote').textContent = product ? `${currency(product.price)} per pair. Free UK Next Day Recorded delivery after dispatch.` : 'This specification requires a quote. UK Next Day Recorded delivery is free after dispatch.';
  purchaseForm.hidden = !product || !product.available || purchaseForm.dataset.enabled !== 'true';
  $('#buildPurchaseStatus').textContent = product && !product.available ? 'This finish is currently unavailable. Ask the team for alternatives.' : '';
  $('#addBuild').disabled = purchaseForm.hidden;
  $('#addBuild').textContent = 'Add plates to basket';
  $('#buildVariant').value = product?.variantId || '';
  const inputs = $('#buildProperties');
  inputs.replaceChildren();
  for (const [key, value] of Object.entries(orderProperties(reviewedState))) {
    const input = document.createElement('input');
    input.type = 'hidden'; input.name = `properties[${key}]`; input.value = value;
    inputs.append(input);
  }
  const message = ['Hello, could you confirm this physical plate specification and final quote? I would like UK Next Day Recorded delivery, or an overseas quote if applicable.', ...details().map(([key, value]) => `${key}: ${value}`)].join('\n');
  $('#enquireBuild').href = `https://wa.me/447466288265?text=${encodeURIComponent(message)}`;
  $('#saveStatus').textContent = '';
  $('#saveBuild').disabled = false;
  dialog.showModal();
  document.body.classList.add('no-scroll');
});
$('#closeReview').addEventListener('click', () => dialog.close());
purchaseForm.addEventListener('submit', event => {
  const product = reviewedState && configuredProduct(reviewedState, catalogue);
  if (!product?.available || purchaseForm.dataset.enabled !== 'true' || Object.keys(validate(reviewedState, $('#entitlement').checked)).length) {
    event.preventDefault();
    $('#buildPurchaseStatus').textContent = 'Review and confirm a valid configuration before adding it to your basket.';
    return;
  }
  $('#addBuild').disabled = true;
  $('#addBuild').textContent = 'Adding plates...';
});
dialog.addEventListener('close', () => document.body.classList.remove('no-scroll'));
dialog.addEventListener('click', event => {if (event.target === dialog) {const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();}});
$('#saveBuild').addEventListener('click', () => {
  try {
    localStorage.setItem(storageKey, JSON.stringify(reviewedState));
    $('#saveStatus').textContent = 'Saved on this device. No order has been placed.';
  } catch { $('#saveStatus').textContent = 'Device storage is unavailable. Download your specification instead.'; }
});
$('#downloadSpec').addEventListener('click', () => {
  const product = configuredProduct(reviewedState, catalogue);
  const spec = {...specification(reviewedState), estimatedPairPriceGBP: product?.price ?? null, pricingStatus: product ? 'current-shopify-price' : 'quote-required'};
  const blob = new Blob([JSON.stringify(spec, null, 2)], {type: 'application/json'});
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a'); a.href = url; a.download = 'the-plate-dealer-specification.json'; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
  $('#saveStatus').textContent = 'Specification prepared for download. This is not an order.';
});
$('#resetBuild').addEventListener('click', () => {
  state = {...defaults}; attempted = false; $('#entitlement').checked = false;
  try { localStorage.removeItem(storageKey); } catch { /* Build can still be reset without storage. */ }
  syncControls(); render(); notify('Build reset.');
});
syncControls(); render();
